export const SHARE_ASSETS = {
  hero: '/share/pr-dumbbell-arrow-v2.png', photo: '/share/bench-press-v2.png', qr: '/share/lianke-qr-v1.png',
};
export type ShareAssetImages = typeof SHARE_ASSETS;
